<style>
    .legal-wrapper {
  text-align: left;
}

.legal-title {
  font-size: 23px;
  font-weight: 600;
  margin-bottom: 15px;
}

.legal-text {
  font-size: 14px;
  line-height: 1.5;
  color: #444;
}

.legal-text p {
  margin-bottom: 10px;
}
</style>

<template>
  <div class="underLogoPhrase ">

    <h2 class="font-weight-bold mb-4 centers">
      Mentions légales
    </h2>
    <br>

    <div class="legal-text">
      <p><strong>Éditeur du site</strong></p>
      <p>
        Association {{ $seo.fullName }}<br>
        Association loi 1901<br>
        Route de Sampans, Biarne, France, 39290
      </p>

      <p><strong>Responsable de la publication</strong></p>
      <p>
        Association {{ $seo.fullName }}
      </p>

      <p><strong>Hébergement</strong></p>
      <p>
        OVH SAS – 2 rue Kellermann, 59100 Roubaix – France<br>
        RCS Lille Métropole 424 761 419 00045
      </p>

      <p><strong>Données personnelles</strong></p>
      <p>
        Le site ne collecte aucune donnée personnelle via formulaire.
        Il utilise uniquement Google Analytics à des fins de mesure d’audience.
      </p>

      <p><strong>Droit applicable</strong></p>
      <p>
        Les présentes mentions légales sont régies par le droit français.
      </p>
    </div>

  </div>
</template>